import { QueryClient } from "@tanstack/react-query";

import { parseApiError } from "@/api/errors";

/** 4xx qayta so'ralmaydi: natija o'zgarmaydi, faqat foydalanuvchi kutib qoladi. */
export function shouldRetry(failureCount: number, error: unknown): boolean {
  const { status, code } = parseApiError(error);
  if (status !== undefined && status >= 400 && status < 500) return false;
  if (code === "UNKNOWN_ERROR" && status === undefined) return false;
  return failureCount < 2;
}

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: { retry: shouldRetry, staleTime: 30_000, refetchOnWindowFocus: false },
      mutations: { retry: false },
    },
  });
}
